import * as Yup from 'yup'

export const checkoutFormSchema = Yup.object({
    // firstName: Yup.string().min(3, 'Min is 3').max(30, 'Max is 30').required('Required'),
    // lastName: Yup.string().min(3, 'Min is 3').max(30, 'Max is 30').required('Required'),
    // company: Yup.string().min(3, 'Min is 3').max(30, 'Max is 30'),
    country: Yup.string().required('REquried'),
    // address: Yup.string(),
    city: Yup.string().min(3, 'Min is 3').max(30, 'Max is 30').required('Requried'),
    state: Yup.string().required('Required'),
    street: Yup.string().required('Required'),
    zip: Yup.number().required('Requred'),
    // email: Yup.string().email('Email is Invalid').required('Requird')
})